import { render, staticRenderFns } from "./InfoItemModal.vue?vue&type=template&id=71b65e6f&scoped=true"
import script from "./InfoItemModal.vue?vue&type=script&lang=js"
export * from "./InfoItemModal.vue?vue&type=script&lang=js"
import style0 from "./InfoItemModal.vue?vue&type=style&index=0&id=71b65e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b65e6f",
  null
  
)

export default component.exports